import {
    AudioAssetColumn,
    CaptionAssetColumn,
    FileAssetColumn,
    ImageAssetColumn,
    PreviewAssetColumn,
    VideoAssetColumn,
} from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-assets";
import {
    AudioAssetColumn as AudioAssetMixedColumn,
    CaptionAssetColumn as CaptionAssetMixedColumn,
    FileAssetColumn as FileAssetMixedColumn,
    ImageAssetColumn as ImageAssetMixedColumn,
    PreviewAssetColumn as PreviewAssetMixedColumn,
    VideoAssetColumn as VideoAssetMixedColumn,
} from "@features/autocomplete-table/autocomplete-table-mixed-columns/autocomplete-table-columns-assets";
import {
    CustomContentColumn,
    MusicContentColumn,
    PeopleContentColumn,
    PhotoContentColumn,
    VideoContentColumn,
} from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-contents";
import { CollectionColumn } from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-collections";
import { LinkContentColumn } from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-links";
import * as React from "react";
import { MixedColumn } from "@features/autocomplete-table/autocomplete-table-columns/autocomplete-table-columns-mixed";
import { MixedColumn as SummaryMixedColumn } from "@features/autocomplete-table/autocomplete-table-list-columns/autocomplete-table-list-columns-mixed";

export const useAutocompleteTable = () => {
    const getResourceType = (type) => {
        if (type.indexOf("CONTENT") >= 0) return "CONTENT";
        else if (type.indexOf("ASSET") >= 0) return "ASSET";
        else if (type.indexOf("COLLECTION") >= 0) return "COLLECTION";
        else if (type.indexOf("LINK") >= 0) return "LINK";
    };
    const getTableColumns = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "VIDEO":
                    return VideoAssetColumn;
                case "AUDIO":
                    return AudioAssetColumn;
                case "IMAGE":
                    return ImageAssetColumn;
                case "CAPTION":
                    return CaptionAssetColumn;
                case "PREVIEW":
                    return PreviewAssetColumn;
                case "FILE":
                    return FileAssetColumn;
                default:
                    return MixedColumn;
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return VideoContentColumn;
                case "MUSIC":
                    return MusicContentColumn;
                case "PEOPLE":
                    return PeopleContentColumn;
                case "PHOTO":
                    return PhotoContentColumn;
                case "CUSTOM":
                    return CustomContentColumn;
            }
        } else if (type === "COLLECTION") {
            return CollectionColumn;
        } else if (type === "LINK") {
            return LinkContentColumn;
        }
    };

    const getTableMixedColumns = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "VIDEO":
                    return VideoAssetMixedColumn;
                case "AUDIO":
                    return AudioAssetMixedColumn;
                case "IMAGE":
                    return ImageAssetMixedColumn;
                case "CAPTION":
                    return CaptionAssetMixedColumn;
                case "PREVIEW":
                    return PreviewAssetMixedColumn;
                case "FILE":
                    return FileAssetMixedColumn;
                default:
                    return FileAssetMixedColumn;
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return VideoContentColumn;
                case "MUSIC":
                    return MusicContentColumn;
                case "PEOPLE":
                    return PeopleContentColumn;
                case "PHOTO":
                    return PhotoContentColumn;
                case "CUSTOM":
                    return CustomContentColumn;
            }
        } else if (type === "COLLECTION") {
            return CollectionColumn;
        } else if (type === "LINK") {
            return LinkContentColumn;
        }
    };

    const getSmallTableColumns = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "PREVIEW":
                    return PreviewAssetColumn;
                default:
                    return SummaryMixedColumn;
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return VideoContentColumn;
                case "MUSIC":
                    return MusicContentColumn;
                case "PEOPLE":
                    return PeopleContentColumn;
                case "PHOTO":
                    return PhotoContentColumn;
                case "CUSTOM":
                    return CustomContentColumn;
            }
        } else if (type === "COLLECTION") {
            return CollectionColumn;
        } else if (type === "LINK") {
            return LinkContentColumn;
        }
    };
    const getSubNameIds = (type, subType) => {
        if (type === "ASSET") {
            switch (subType) {
                case "VIDEO":
                case "AUDIO":
                    return ["extensions", "duration", "size"];
                case "IMAGE":
                case "CAPTION":
                    return ["type", "size"];
                case "PREVIEW":
                    return ["extensions"];
                case "FILE":
                    return ["extensions", "size"];
                default:
                    return ["extensions", "size"];
            }
        } else if (type === "CONTENT") {
            switch (subType) {
                case "VIDEO":
                    return ["extensions"];
                case "MUSIC":
                case "PEOPLE":
                case "PHOTO":
                case "CUSTOM":
                    return [];
            }
        } else if (type === "COLLECTION") {
            return [];
        } else if (type === "LINK") {
            return [];
        }
    };

    return {
        getResourceType,
        getTableColumns,
        getSmallTableColumns,
        getSubNameIds,
        getTableMixedColumns,
    };
};
